import script from "./labelWrapper.vue?vue&type=script&lang=js"
export * from "./labelWrapper.vue?vue&type=script&lang=js"

import "./labelWrapper.vue?vue&type=style&index=0&id=893f8e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-893f8e34"]])

export default __exports__